import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { User } from '../models/user';
import { AppStateService } from '../shared/app-state.service';
import { BaseService } from '../shared/base.service';


export class LoginResponse {
  message = '';
  token = '';
  user = new User;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseService {
  currentUser: User;
  redirectUrl = '/';
  private _isAdmin = false;
  _isLoggedIn = false;
  isLoggedIn$: Subject<boolean> = new Subject<boolean>();

  token = '';

  constructor(http: HttpClient, messageService: MessageService, appState: AppStateService, private router: Router) {
    super(http, messageService, appState);

    if (this.getToken()) {
      this.isLoggedIn = true;
      this.currentUser = Object.assign(new User(), JSON.parse(localStorage.getItem('user')));
      this._isAdmin = this.currentUser.roles.findIndex(role =>
        ((role.name === 'superadministrator') || (role.name === 'administrator'))) !== -1;
    }

    this.appState.forcedLogOut$.subscribe((status) => {
      if (status) { this.logout(); }
    });
  }

  get isAdmin(): boolean { return this._isAdmin; }
  get isLoggedIn() { return this._isLoggedIn; }
  set isLoggedIn(status) {
    this._isLoggedIn = status;
    this.isLoggedIn$.next(this.isLoggedIn);
  }

  login(user: string, password: string) {
    const loginUrl = this.apiUrl + '/login';
    this.http.post<LoginResponse>(loginUrl, { 'email': user, 'password': password }, this.httpOptions)
      .subscribe(
        (response) => {
          if (response.message === 'success') {
            this._isAdmin = response.user.roles.findIndex(role =>
              ((role.name === 'superadministrator') || (role.name === 'administrator'))) !== -1;

            if (this.isAdmin) {
              console.log('User succesfully logged in!');
              this.isLoggedIn = true;
              this.token = response.token;
              this.currentUser = response.user;

              localStorage.setItem('token', this.token);
              localStorage.setItem('user', JSON.stringify(this.currentUser));
              this.router.navigate([this.redirectUrl]);
            } else {
              console.log('User not authorized!');
              this.messageService.add({
                severity: 'error',
                summary: 'Keine Zugangsberechtigung!',
                detail: 'Sie verfügen nicht über die notwendigen Zugriffsrechte für diese Seiten!'
              });
              this.isLoggedIn = false;
              localStorage.removeItem('token');
              this.router.navigate(['login']);
            }
          }
        },
        (error: HttpErrorResponse) => {
          console.log('User login failed!');
          this.messageService.add({
            severity: 'error',
            summary: 'User login failed!',
            detail: 'Bitte prüfen Sie Emailadresse und Passwort!'
          });
          this.isLoggedIn = false;
          localStorage.removeItem('token');
        },
        () => this.isLoggedIn$.next(this.isLoggedIn));
  }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    this.currentUser = null;
    this.isLoggedIn = false;
    this.isLoggedIn$.next(this.isLoggedIn);
    this.router.navigate(['/']);
  }

}
